import { render, staticRenderFns } from "./ad-artist.vue?vue&type=template&id=a86f1c9c"
import script from "./ad-artist.vue?vue&type=script&lang=js"
export * from "./ad-artist.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports